import { DashExceptions } from './consts.js';
import { WaitFetch, convertPkmNameToURI, pkmJSON } from './helper.js';

$(window).on("load", async function () {
	await WaitFetch();

	$("#searchPokemon").on("keyup paste focusin", function (e) {
		if (e.type == "keyup") {
			let skipReturn = false;
			
			if (e.key?.length == 1 && e.key?.match(/[a-z0-9.-]/i) || e.key == "Backspace")
				skipReturn = true;

			if (!skipReturn)
				return;
		}

		// https://api.jquery.com/category/events/event-object/
		$("#dropdownContentSearch").html("");
		let searchVal = ($(this).val() as string).toLowerCase();

		if (searchVal == "")
			return;

		let pkmList: string[] = [];
		Object.keys(pkmJSON!).forEach((pkm) => {
			if (pkm.toLowerCase().includes(searchVal) &&
					(!pkm.includes("-") || DashExceptions.includes(pkm)))
				pkmList.push(pkm);
		});

		if (pkmList.length == 0 && searchVal != "") {
			let appendString = "<p><i>No results found.</i></p>";
			$("#dropdownContentSearch").append(appendString);
			return;
		}

		pkmList.sort((a, b) => a.localeCompare(b));

		pkmList.forEach((val, idx) => {
			let appendString = `<a href="/dex/${convertPkmNameToURI(val)}"${idx == pkmList.length - 1 ? `class="lastResult"`: ""}><p>${val}</p></a>`;
			$("#dropdownContentSearch").append(appendString);
		});
	});

	$("#searchPokemon").on("focusout", function (e) {
		if (e.relatedTarget) {
			if ($(e.relatedTarget).is("a"))
				return;
		}

		$("#dropdownContentSearch").html("");
	});

	$("#searchPokemon").on("keyup", function (e) {
		if (e.key != "Enter" && e.key != "ArrowUp" && e.key != "ArrowDown")
			return;

		let dropdownContentChildren = $("#dropdownContentSearch").children("a");

		if (dropdownContentChildren.length == 0)
			return;
			
		let activeFocusElement = $($("#dropdownContentSearch").find(".activeFocus")[0]);
		let activeFocusIndex = activeFocusElement.index();
		
		if (e.key == "ArrowDown") {
			if (activeFocusElement.length == 0) {
				$(dropdownContentChildren[0]).addClass("activeFocus");
			}
			else {
				activeFocusElement.removeClass("activeFocus");

				let nextFocusIndex = activeFocusIndex == dropdownContentChildren.length - 1 ? activeFocusIndex : activeFocusIndex + 1;
				$(dropdownContentChildren[nextFocusIndex]).addClass("activeFocus");
			}
		}
		else if (e.key == "ArrowUp") {
			if (activeFocusElement.length == 0) {
				$(dropdownContentChildren[0]).addClass("activeFocus");
			}
			else {
				activeFocusElement.removeClass("activeFocus");

				let prevFocusIndex = activeFocusIndex == 0 ? activeFocusIndex : activeFocusIndex - 1;
				$(dropdownContentChildren[prevFocusIndex]).addClass("activeFocus");
			}
		}
		else if (e.key == "Enter") {
			if (activeFocusElement.length != 0) {
				let activeFocusPkmName = $(activeFocusElement.children("p")[0]).text();
				location.href = `/dex/${convertPkmNameToURI(activeFocusPkmName)}`;
			}
		}
	});
});